const API_BASE = 'https://mulata.pt/bolacha-mulata/api';

function getAuthHeaders(): Record<string, string> {
  const token = localStorage.getItem('adminToken');
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}

function getAuthHeadersMultipart(): Record<string, string> {
  const token = localStorage.getItem('adminToken');
  const headers: Record<string, string> = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}

export async function apiGet(endpoint: string) {
  const response = await fetch(`${API_BASE}/${endpoint}`);
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }
  return response.json();
}

export async function apiPut(endpoint: string, data: unknown) {
  const response = await fetch(`${API_BASE}/${endpoint}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(data),
  });
  
  if (response.status === 401) {
    // Token expired or invalid - force re-login
    localStorage.removeItem('adminToken');
    window.location.href = '/admin';
    throw new Error('Sessão expirada. Por favor, faça login novamente.');
  }
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }
  
  return response.json();
}

export async function apiPost(endpoint: string, data: unknown) {
  const response = await fetch(`${API_BASE}/${endpoint}`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(data),
  });
  
  if (response.status === 401) {
    localStorage.removeItem('adminToken');
    window.location.href = '/admin';
    throw new Error('Sessão expirada. Por favor, faça login novamente.');
  }
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }
  
  return response.json();
}

export async function apiDelete(endpoint: string) {
  const response = await fetch(`${API_BASE}/${endpoint}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  
  if (response.status === 401) {
    localStorage.removeItem('adminToken');
    window.location.href = '/admin';
    throw new Error('Sessão expirada. Por favor, faça login novamente.');
  }
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }
  
  return response.json();
}

export async function apiUpload(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await fetch(`${API_BASE}/upload.php`, {
    method: 'POST',
    headers: getAuthHeadersMultipart(),
    body: formData,
  });
  
  if (response.status === 401) {
    localStorage.removeItem('adminToken');
    window.location.href = '/admin';
    throw new Error('Sessão expirada. Por favor, faça login novamente.');
  }
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Upload failed' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }
  
  return response.json();
}

export { API_BASE };
